module.exports = __webpack_public_path__ + "media/preview/man-on-phone-1c45a823.png";